import React from 'react';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import Modal from 'components/Modal';
import { i18n } from 'utils/i18n';
import FrequentTravelerRecoveryFeeModalContent from 'components/FrequentTravelerRecoveryFeeModalContent';

const FrequentTravelerRecoveryFeeModal = () => (
  <Modal
    modalKey={MODAL.FREQUENT_TRAVELER_RECOVERY_FEE_MODAL}
    header={i18n('partner_rewards_modal_title')}
    theme={MODAL_THEMES.WHITE}
  >
    {({ handleClose }) => (
      <FrequentTravelerRecoveryFeeModalContent
        describedByID={`${MODAL.FREQUENT_TRAVELER_RECOVERY_FEE_MODAL}_desc`}
        handleClose={handleClose}
      />
    )}
  </Modal>
);

export default FrequentTravelerRecoveryFeeModal;
